import Player from '@vimeo/player';
export default (videoId) => ({
  videoId: null,
  isPresented: false,
  playing: false,
  showControlButton: false,
  animationTreshold: 'homepage-video-section',
  options: {
    id: 'https://player.vimeo.com/video/' + videoId,
    width: 1425,
    muted: true,
    background: true,
    controls: false,
    loop: true,
  },
  init() {
    this.videoId = this.$el.id;
    this.initVideo();
    this.animateVideoOnScroll();
  },

  initVideo() {
    const player = new Player(this.videoId, this.options);
    player.play().then(() => {
      setTimeout(() => {
        this.showControlButton = true;
      }, 800);
    });
  },

  presentVideo() {
    const player = new Player(this.videoId);

    if (this.isPresented) {
      player.getPaused().then(function (paused) {
        if (paused) {
          player.play();
        } else {
          player.pause();
        }
      });
    } else {
      player.setCurrentTime(0);
      player.setMuted(false);
      player.play();
      this.playing = false;
      this.isPresented = true;
    }
  },

  animateVideoOnScroll() {
    animateVideo();
  },
});

function animateVideo() {
  const video = document.getElementById('homepage-video');
  const rect = video.parentElement.getBoundingClientRect();
  if (rect.top - 50 <= window.innerHeight) {
    if (!video.classList.contains('homepage-video--visible')) {
      video.classList.add('homepage-video--visible');
    }
    let top = -video.offsetHeight + (window.innerHeight - rect.top);
    if (top < 0) {
      video.style.top = top + 'px';
    } else {
      video.style.top = '0px';
    }
  }
  requestAnimationFrame(animateVideo);
}
